export default {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};
